import { RefreshCw, AlertTriangle } from 'lucide-react';
import { colors } from '../../styles/colors';
import ActionButton from '../ActionButton';

/**
 * RecalculConfirmModal - Modale de confirmation pour le recalcul de tous les TMP
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - État d'ouverture de la modale
 * @param {function} props.onClose - Callback de fermeture
 * @param {function} props.onConfirm - Callback de confirmation
 */
function RecalculConfirmModal({ isOpen, onClose, onConfirm }) {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        fontFamily: '"Noto Sans", sans-serif'
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: colors.text.white,
          borderRadius: '1rem',
          width: '90%',
          maxWidth: '500px',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
          overflow: 'hidden'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header modal */}
        <div
          style={{
            backgroundColor: colors.primary.teal,
            color: colors.text.white,
            padding: '1rem 1.25rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem'
          }}
        >
          <RefreshCw size={24} />
          <h3
            style={{
              margin: 0,
              fontSize: '1.125rem',
              fontWeight: '700',
              fontFamily: '"Century Gothic Bold", "Noto Sans", sans-serif'
            }}
          >
            Recalculer tous les TMP
          </h3>
        </div>

        {/* Contenu modal */}
        <div style={{ padding: '1.5rem' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '1rem',
              marginBottom: '1.5rem'
            }}
          >
            <AlertTriangle
              size={24}
              color={colors.primary.gold}
              style={{ flexShrink: 0, marginTop: '0.25rem' }}
            />
            <div>
              <p
                style={{
                  margin: '0 0 0.75rem 0',
                  fontSize: '0.9375rem',
                  color: colors.primary.gray,
                  lineHeight: '1.5'
                }}
              >
                Cette opération va parcourir tous les temps saisis et mettre à jour la table Calcul
                TMP.
              </p>
              <p
                style={{
                  margin: 0,
                  fontSize: '0.875rem',
                  color: colors.secondary.mediumGray,
                  lineHeight: '1.5'
                }}
              >
                Êtes-vous sûr de vouloir continuer ?
              </p>
            </div>
          </div>

          {/* Boutons d'action */}
          <div
            style={{
              display: 'flex',
              gap: '0.75rem',
              justifyContent: 'flex-end'
            }}
          >
            <ActionButton text="Annuler" onClick={onClose} variant="secondary" />
            <ActionButton text="Confirmer le recalcul" onClick={onConfirm} variant="primary" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecalculConfirmModal;
